module.exports = __webpack_public_path__ + "media/assets/icons/icon_security-e033b636eff1d757d92ffa71293c93cb.svg";